export const PRESERVE_ASPECT_RATIO_STORAGE_KEY = 'preserve_video_aspect_ratio';
